import React from "react";
import metaData from "../../data/metaData";

const ShopLogo = ({ logo, brandLogo, style }) => {
  const getLogoUrl = () => {
    if (logo) {
      return `${metaData.blobPreURL}clientUpload-${logo}.jpeg${metaData.blobPostURL}`;
    }
    if (brandLogo) {
      return `${metaData.blobPreURL}clientUpload-${brandLogo}.jpeg${metaData.blobPostURL}`;
    }
    return null;
  };

  const logoUrl = getLogoUrl();

  return logoUrl ? (
    <img
      style={{
        ...style, // Allow custom styles to override defaults
      }}
      src={logoUrl}
    />
  ) : null;
};

export default ShopLogo;
